import {PaginationState, Updater} from "@tanstack/react-table";
import {useDispatch} from "react-redux";
import {useLocation} from "react-router-dom";

const useChangeMrtReduxPagination = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const handleChangePagination = (
    value: Updater<PaginationState>,
    type: string,
    keyName: string,
    oldValue,
  ) => {
    if (typeof value === "function") {
      dispatch({
        type: type,
        [keyName]: value(oldValue),
      });
    } else {
      dispatch({
        type: type,
        [keyName]: value,
      });
    }
  };

  const resetPagination = (
    type: string,
    keyName: string,
    currentValue: {
      pageIndex: number;
      pageSize: number;
      totalNumberOfPages?: number;
    },
    pathnamesList: string[],
  ) => {
    const matchingPathname: string[] = [];

    for (const item of pathnamesList) {
      if (location.pathname.includes(item)) {
        matchingPathname.push(item);
      }
    }

    if (matchingPathname.length !== 0) return;
    if (currentValue.pageIndex === 0) return;

    dispatch({
      type: type,
      [keyName]: {
        ...currentValue,
        pageIndex: 0,
        pageSize: currentValue.pageSize ?? 20,
      },
    });
  };

  return {handleChangePagination, resetPagination};
};

export default useChangeMrtReduxPagination;
